export default __webpack_public_path__ + "static/media/3d-secure-logo.5f6a28be.webp";